import { useState } from "react";
import { format, parseISO } from "date-fns";
import { id as localeID } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const toISO = (d) => format(d, "yyyy-MM-dd");
const fromISO = (s) => (s ? parseISO(s) : undefined);

// 2 klik: klik 1 = tanggal mulai, klik 2 = tanggal selesai (popup tutup otomatis)
export function DateRangePicker({ start, end, onChange, minDate, testId = "date-range", className = "" }) {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(null);
  const range = pending || { from: fromISO(start), to: fromISO(end) };

  const handleSelect = (r, day) => {
    if (!pending) {
      setPending({ from: day, to: undefined });
      return;
    }
    let from = pending.from, to = day;
    if (to < from) [from, to] = [to, from];
    if (toISO(from) === toISO(to)) to = new Date(from.getTime() + 86400000);
    onChange(toISO(from), toISO(to));
    setPending(null);
    setOpen(false);
  };

  const label = start && end
    ? `${format(fromISO(start), "d MMM yyyy", { locale: localeID })} → ${format(fromISO(end), "d MMM yyyy", { locale: localeID })}`
    : "Pilih tanggal";

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (!o) setPending(null); }}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className={`w-full flex items-center gap-2 h-10 px-3 rounded-md border border-neutral-200 bg-white text-sm text-left hover:border-neutral-400 transition-colors ${className}`}>
          <CalendarDays className="w-4 h-4 text-neutral-500 shrink-0" />
          <span className="truncate font-medium">{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <div className="px-3 pt-3 text-xs text-neutral-500">
          {pending ? "Klik tanggal kembali" : "Klik tanggal ambil"}
        </div>
        <Calendar
          mode="range"
          locale={localeID}
          selected={range}
          onSelect={handleSelect}
          disabled={minDate ? { before: fromISO(minDate) } : undefined}
          numberOfMonths={1}
          defaultMonth={fromISO(start)}
        />
      </PopoverContent>
    </Popover>
  );
}
